
import {Component} from 'vue-property-decorator';
import {deletePendingSession, fetchPendingSessions} from '@/repositories/api/PendingSessionApi';
import BaseListView from '@/views/BaseListView.vue';
import ItemModel from '@/models/ItemModel';
import Alert from '@/models/Alert';
import {AlertTypes} from '@/models/AlertTypes';

@Component
export default class SessionPendingView extends BaseListView {
  title = 'En attente';
  fetchItems: Function = fetchPendingSessions;
  newItemLabel = 'Nouvel import';
  headers = [
    {
      text: '#',
      align: 'left',
      sortable: true,
      value: 'id',
    },
    {text: 'Nom', value: 'name'},
    {text: 'Actions', value: 'action', sortable: false, align: 'right'},
  ];
  protected viewLabel = 'En attente';
  protected deleteDialog = false;
  protected loading = false;
  protected selectedDeleteDialog = false;
  protected overlay = false;
  protected overlayText = 'Chargement...';
  protected items: {id: number, name: string}[] = [];
  protected itemModels: ItemModel[] = [];
  protected sessionDeleter: Function = deletePendingSession;
  protected deleteIndex: number = -1;
  protected alert: Alert = new Alert();
  protected selected: {id: number, name: string}[] = [];

  newItemAction(){
    this.$router.push({name: 'session_import'})
  }

  async deleteSession(session: { id: number, name: string }): Promise<boolean> {
    let deleted = false;
    this.overlay = true;
    this.overlayText = 'Suppression de la session ' + session.name + ' en cours...';

    try {
      const response: { status: string, message: string } = await this.sessionDeleter(session.name);

      if(response.status == 'success'){
        deleted = true;
      }

      this.alert = new Alert(response.message, response.status, true);
    } catch (e) {
      this.alert = new Alert(e.toString(), AlertTypes.Error, true);
    }

    this.overlay = false;

    return deleted;
  }

  async processDeleteItem() {
    this.deleteDialog = false;
    if (await this.deleteSession(this.items[this.deleteIndex])) {
      this.items.splice(this.deleteIndex, 1);
    }
  }

  async processSelectedDeleteItem() {
    this.selectedDeleteDialog = false;
    for (const session of this.selected) {
      if (await this.deleteSession(session)) {
        this.selected.splice(this.selected.indexOf(session), 1);
        this.items.splice(this.items.indexOf(session), 1);
      }
    }
  }
}
